module.exports = __webpack_public_path__ + "img/burger.d9a45746.svg";